import { WidgetData } from '@recruitee/dashboard-types';
import { createSingleEntityStore, getSingleEntityActions } from '@recruitee/ngrx';

const { actions, reducer, selectors, namespace } = createSingleEntityStore<WidgetData[]>()(
  'DashboardWidgets',
  {
    customActions: adapter => {
      const defaultActions = getSingleEntityActions(adapter);
      return {
        update: (state, payload: WidgetData[]) => defaultActions.update(state, payload),
        updateSuccess: (state, payload: WidgetData[]) =>
          defaultActions.fetchSuccess(state, payload),
      };
    },
  },
);

export {
  actions as DashboardWidgetsActions,
  reducer as DashboardWidgetsReducer,
  selectors as DashboardWidgetsSelectors,
  namespace as DashboardWidgetsNamespace,
};
